import { Component } from '@angular/core';
import { ResultsPaginationHeaderDirective } from '../results-pagination-header.directive';


@Component({
  selector: 'app-ged-results-pagination-header',
  templateUrl: './ged-results-pagination-header.component.html',
  styleUrls: ['../results-pagination-header.component.scss']
})
export class GedResultsPaginationHeaderComponent extends ResultsPaginationHeaderDirective {}
